import fromObjectToKeys from 'utils/converters/object/fromObjectToKeys.util';
import owns from 'utils/objects/owns.util';
import isNilValue from 'utils/predicates/any/isNilValue.util';

// React uses Object.is for comparing props
const eq = Object.is;

const equalShallow = (a, b) => {
  if (eq(a, b)) return true;

  // since the above check will have both null or both undefined,
  // this means they aren't same
  if (isNilValue(a) || isNilValue(b)) return false;

  const aKeys = fromObjectToKeys(a);
  const bKeys = fromObjectToKeys(b);

  if (aKeys.length !== bKeys.length) return false;

  for (const key of aKeys) {
    if (!owns(key, b)) return false;
    if (!eq(a[key], b[key])) return false;
  }

  return true;
};

export default equalShallow;
